import { Box, styled } from '@mui/material';

export const PaginationContainer = styled(Box)`
  height: 75px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
